import React, { createRef, useRef, useState } from "react";
import "./DateForm.css";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import TextField from "@mui/material/TextField";
import { DATE_DISPLAY_FORMAT } from "../../Helpers/Constants/Constants";

const DateForm = ({
  isDisabled,
  value,
  onChange,
  disableFuture = false,
  displayFormat = DATE_DISPLAY_FORMAT,
  ...rest
}) => {
  const handleInputClick = (e) => {
    e.preventDefault(); // Prevents manual typing
    //e.target.click(); // Opens the date picker on click
    //return false;
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        disabled={isDisabled}
        value={value}
        disableMaskedInput={true}
        className="w-100 bg-white"
        onChange={onChange}
        inputFormat="dd-MM-yyyy"
        renderInput={(params) => (
          <TextField
            size="small"
            name="paValue"
            onClick={handleInputClick}
            autoComplete="new-password"
            disabled={true}
            onKeyDown={(e) => {
              e.preventDefault();
            }}
            style={{
              cursor: "pointer",
              caretColor: "transparent",
            }}
            {...params}
          />
        )}
        disableFuture={disableFuture}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default DateForm;
